import init from 'utilities/init'

preImportActions()

// Import components

import Carousel from 'components/Carousel'
import FullPage from 'components/FullPage'
import SmoothScrollbar from 'components/SmoothScrollbar'
import Form from 'components/Form'
import PointerHover from 'components/PointerHover'
import ScrollTo from 'components/ScrollTo'
import ResizeRefresh from 'components/ResizeRefresh'

// Init components

// Prevent JS components to be initialized before CSS
//
// Webpack 'style-loader' is used for development server for HMR work for styles. It injects styles via JS.
// Some components (as carousel) might perform wrong calculations on page load due not loaded CSS
window.onload = () => {
    ResizeRefresh()

    init.single(FullPage, document.querySelector('.js-fullpage'))
    init.single(SmoothScrollbar, document.querySelector('.js-scrollbar'))
    init.single(Form, document.querySelector('.js-form'))

    init.multiple(ScrollTo, document.querySelectorAll('.js-anchor'))
    init.multiple(Carousel, document.querySelectorAll('.js-carousel'))
    init.single(PointerHover, [
        ...document.querySelectorAll('.js-pointer-hover'),
    ])
}

/**
 * Actions needed to perform before importing components
 */
function preImportActions() {
    // 1. Glide.js - Do not trigger slider when clicking on active bullet
    //
    // If the imported component assigns event listeners inside, our custom event listeners defined later will be invoked also later.
    // Here the order of custom event listener is set as first

    document.querySelectorAll('.glide__bullet').forEach(bullet => {
        bullet.addEventListener('click', e => {
            if (e.currentTarget.classList.contains('glide__bullet--active')) {
                e.stopImmediatePropagation()
            }
        })
    })
}
